import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { LocationMovementsApiAdapter } from '../adapters/LocationMovementsApiAdapter';
import { Service } from '../services/Service';
import { Filters } from '../models/Filters';

// Instancias compartidas
const httpClient = createHttpClient(apiClientWH);
const apiAdapter = new LocationMovementsApiAdapter(httpClient);
const service = new Service(apiAdapter);

export const useExportLocationMovements = () =>
  useMutation<string, Error, Filters>({
    mutationFn: (filters) => service.exportToExcel(filters),
  });
